import keepRouteCurrent from './keepRouteCurrent';
import navigateToRoute from './navigateToRoute';
import RouterOptions from './RouterOptions';
import router from './routerInstance';

export default function initializeRouter(routerOptions: RouterOptions) {
    if (routerOptions) {
        router.configure({
            notfound: () => {
                routerOptions.routeGenerator.then(generator => {
                    navigateToRoute(generator());
                });
            },
            html5history: true,
            convert_hash_in_init: false,
            run_handler_in_init: true,
            strict: false,
            async: true,
        });

        router.init();
        routerOptions.routeGenerator.then(generator => {
            keepRouteCurrent(generator);
        });
    }
}
